var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'checkbox check-' + _vm.type,staticStyle:{"margin-right":"auto","margin-left":"auto"}},[_c('input',{attrs:{"type":"checkbox","id":_vm.id},domProps:{"value":_vm.val}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }